import React, { useState, useEffect } from 'react'
import '../styles/basicLayout.css'
import back from "../assets/back.png";
import Clock from "../assets/clock-icon.png";
import ambientTemp from "../assets/ambientTemp.png";
import actionProd from "../assets/action.png";
import prodTemp from "../assets/productTemp.png";
import start from "../assets/star-icon.png"
import { MIN_GRILL_TEMP_F, MIN_PROD_TEMP_F, MIN_TIME_S, MAX_PROD_TEMP_F, MAX_GRILL_TEMP_F } from "../utils/constants";
import { useLocation, useParams, useHistory } from "react-router-dom";
import Stages from '../components/Stages';
import * as workerTimers from 'worker-timers';
import { saveRecipeRecords, updateRecipeRecords } from "../api";

const readProdTemp = () => {
  return Math.floor(Math.random() * (MAX_PROD_TEMP_F - MIN_PROD_TEMP_F)) + MIN_PROD_TEMP_F;
}

const readGrillTemp = () => {
  return Math.floor(Math.random() * (MAX_GRILL_TEMP_F - MIN_GRILL_TEMP_F)) + MIN_GRILL_TEMP_F;
}

const StageDisplay = ({ stage }) => {

  const { product_temperature_f, grill_temperature_f, time_s, action, id } = { ...stage }

  if (typeof product_temperature_f !== 'undefined' && typeof grill_temperature_f !== 'undefined')
    return (
      <div style={{ display: 'flex', flexDirection: 'row', width: '60%', alignItems: 'center', textAlign: 'center' }} className='border_box'>
        <div style={{ flex: 1, }} className='right_border_box' ><h4>{id + 1}</h4></div>
        <div style={{ flex: 5, display: 'flex', flexDirection: 'column' }} >
          <div className='under_border_box' >
            <img src={prodTemp} width={40} style={{ marginRight: '40px' }} />
            ({product_temperature_f}°F)
          </div>
          <div >
            <img src={ambientTemp} width={20} style={{ marginRight: '40px' }} />
            ({grill_temperature_f}°F)
          </div>
        </div>
      </div>
    )
  else if (typeof action !== 'undefined')
    return (
      <div style={{ display: 'flex', flexDirection: 'row', width: '60%', alignItems: 'center', textAlign: 'center' }} className='border_box'>
        <div style={{ flex: 1, }} className='right_border_box' ><h4>{id + 1}</h4></div>
        <div style={{ flex: 5, display: 'flex', flexDirection: 'column' }} >
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', textAlign: 'center', justifyContent: 'center' }} >
            <img src={actionProd} width={60} style={{ marginRight: '40px' }} />
            <h3>{action}</h3>
          </div>
        </div>
      </div>
    )
  else if (typeof grill_temperature_f !== 'undefined' && typeof time_s !== 'undefined')
    return (
      <div style={{ display: 'flex', flexDirection: 'row', width: '60%', alignItems: 'center', textAlign: 'center' }} className='border_box'>
        <div style={{ flex: 1, }} className='right_border_box' ><h2>{id + 1}</h2></div>
        <div style={{ flex: 5, display: 'flex', flexDirection: 'column' }} >
          <div className='under_border_box' >
            <img src={Clock} width={40} style={{ marginRight: '40px' }} />
            {time_s} Sec
          </div>
          <div >
            <img src={ambientTemp} width={20} style={{ marginRight: '40px' }} />
            ({grill_temperature_f}°F)
          </div>
        </div>
      </div>
    )
  else
    return (<>Undefined stage type</>)
}

export default function RunRecipe() {

  const location = useLocation()
  const history = useHistory();
  const [currTime, setCurrTime] = useState(0)
  const [currProdTemp, setProdTemp] = useState(115)
  const [currGrillTemp, setGrillTemp] = useState(115)
  const [maxTime, setMaxTime] = useState(2)
  const [running, setRunning] = useState(false)
  const [cookingTimeS, setTime] = useState(0)
  const [recipe, setRecipe] = useState({
    name: 'New recipe',
    stages: [
      {
        id: 0,
        product_temperature_f: MIN_PROD_TEMP_F,
        grill_temperature_f: MIN_GRILL_TEMP_F,
        time_s: MIN_TIME_S,
        action: ''
      }
    ],
    category: null,
    activeStage: 0,
    cooking_term: null,
  })
  const [recipeRecords, setRecipeRecords] = useState({
    start_date: new Date(),
    records: {
      0: {}
    }
  })

  const isCorrectStage = (stage, time) => {
    let timeCount = 0
    for (const locStage of Array(stage + 1).keys()) {
      timeCount += (typeof recipe?.stages[locStage]?.time_s === 'number') ? recipe?.stages[locStage]?.time_s : 0
    }
    return (time <= timeCount)
  }

  const postNewRecipeRecords = async () => {
    if (!running) {
      const resp = await saveRecipeRecords({
        start_date: new Date(),
        records: {
          0: {}
        },
        recipe
      })
      setRecipe({ ...recipe, activeStage: 0 })
      setCurrTime(0)
      setRecipeRecords({
        ...resp.data.data,
        records:{
          0:{}
        }
      })
      setRunning(true)
    }
  }

  const saveParams = async (recipe, currTime) => {
    const activeStage = recipe.activeStage
    const stage = { ...recipe.stages[activeStage] }
    const { product_temperature_f, grill_temperature_f, time_s, action, id } = { ...stage }
    console.log({recs: recipeRecords.records[id]});
    if (typeof product_temperature_f !== 'undefined' && typeof grill_temperature_f !== 'undefined') {
      const product_temps = recipeRecords.records[id]?.product_temperature_f ?? []
      const grill_temps = recipeRecords.records[id]?.grill_temperature_f ?? []
      product_temps.push(readProdTemp())
      grill_temps.push(readGrillTemp())
      updateRecipeRecords({
        ...recipeRecords,
        records: {
          ...recipeRecords?.records,
          [id]: {
            product_temperature_f: product_temps,
            grill_temperature_f: grill_temps
          }
        }
      })
      setRecipeRecords({
        ...recipeRecords,
        records: {
          ...recipeRecords?.records,
          [id]: {
            product_temperature_f: product_temps,
            grill_temperature_f: grill_temps
          }
        }
      })
    }
    else if (typeof grill_temperature_f !== 'undefined' && typeof time_s !== 'undefined') {
      const grill_temps = recipeRecords.records[id]?.grill_temperature_f ?? []
      const times = recipeRecords.records[id]?.time_s ?? []
      grill_temps.push(readGrillTemp())
      times.push(currTime)
      updateRecipeRecords({
        ...recipeRecords,
        records: {
          ...recipeRecords?.records,
          [id]: {
            time_s: times,
            grill_temperature_f: grill_temps
          }
        }
      })
      setRecipeRecords({
        ...recipeRecords,
        records: {
          ...recipeRecords?.records,
          [id]: {
            time_s: times,
            grill_temperature_f: grill_temps
          }
        }
      })
    }
    else if (typeof action !== 'undefined') {
      updateRecipeRecords({
        ...recipeRecords,
        records: {
          ...recipeRecords?.records,
          [id]: {
            action
          }
        }
      })
      setRecipeRecords({
        ...recipeRecords,
        records: {
          ...recipeRecords?.records,
          [id]: {
            action
          }
        }
      })
    }
  }

  useEffect(() => {
    const stages = location?.state?.recipe?.stages || [{}]
    let totalTime = 0
    stages.forEach(stg => {
      totalTime += stg?.time_s
    })
    setTime(totalTime)
    if (typeof stages[0]?.time_s !== 'undefined')
      setMaxTime(stages[0]?.time_s)
    setRecipe({ ...location?.state?.recipe, activeStage: 0 })
  }, [location])

  useEffect(() => {
    if (running) {
      // if (currTime + 1 <= maxTime) {
      //   const intervalId = workerTimers.setInterval(() => {
      //     if (!isCorrectStage(recipe.activeStage, currTime + 1)) {
      //       alert(`Click 'Ok' to continue with the following stage.`)
      //       setRecipe({ ...recipe, activeStage: recipe.activeStage + 1 })
      //     }
      //     if (currTime + 1 && (currTime + 1) % 10 === 0) {
      //       const newTemp = readProdTemp()
      //       const newGrillT = readGrillTemp()
      //       const prodTemps = recipeRecords.product_temperature_records
      //       const times = recipeRecords.time_records
      //       const grillTemps = recipeRecords.grill_temperature_records
      //       prodTemps.push(newTemp)
      //       times.push(currTime + 1)
      //       grillTemps.push(newGrillT)
      //       setProdTemp(newTemp)
      //       setGrillTemp(newGrillT)
      //       updateRecipeRecords({
      //         ...recipeRecords,
      //         time_records: times,
      //         product_temperature_records: prodTemps,
      //         grill_temperature_records: grillTemps
      //       })
      //     }
      //     setCurrTime(currTime + 1)
      //   }, 1000);

      //   return () => {
      //     workerTimers.clearInterval(intervalId)
      //   }
      // }
      if (currTime + 1 <= maxTime) {
        const intervalId = workerTimers.setInterval(() => {
          saveParams(recipe, currTime)
          setCurrTime(currTime + 1)
        }, 1000)
        return () => {
          workerTimers.clearInterval(intervalId)
        }
      }
      else if (recipe.activeStage + 1 < recipe.stages.length) {
        if (typeof recipe.stages[recipe.activeStage]?.action !== 'undefined') {
          alert(`Action required. Please ${recipe.stages[recipe.activeStage]?.action}`)
        }
        else
          alert(`Click 'Ok' to continue with the following stage.`)
        setRecipeRecords({
          ...recipeRecords,
          records: {
            ...recipeRecords?.records,
            [recipe.activeStage + 1]: {}
          }
        })
        setRecipe({ ...recipe, activeStage: recipe.activeStage + 1 })
        setCurrTime(0)
        if (typeof recipe.stages[recipe.activeStage + 1]?.time_s !== 'undefined')
          setMaxTime(recipe.stages[recipe.activeStage + 1]?.time_s)
        else
          setMaxTime(2)

      }
      else {
        alert(`Finished cooking time.`)
        setRunning(false)
      }
    }
  }, [currTime, running])

  return (
    <>
      <header>
        <div className="left">
          <img className="btn" width="80px" src={back} alt="" onClick={() => history.goBack()} />
          <h3 style={{ marginLeft: 10 }}>Click Dial</h3>
        </div>
        <div className="center" style={{ display: 'flex', flexDirection: 'column' }}>
          <h2>Run Mode</h2>
          <h2>{recipe?.name}</h2>
        </div>
        <div className="right">
          <img className="btn" width="80px" src={start} onClick={() => {
            postNewRecipeRecords()

          }} />
          <h3 style={{ marginLeft: 10 }}>Run Recipe</h3>
        </div>
      </header>
      <article>
        <div className="left" style={{ display: 'flex', flexDirection: 'column' }}>
          <img src={Clock} width={85} alt="" />
          <h2>Cooking Time</h2>
          <p style={{ fontSize: 35, textAlign: "center", borderBottom: "2px solid", width: 130 }}>
            {currTime}
          </p>
          <h3>Sec</h3>
        </div>
        <div className="center" style={{ display: 'flex', flexDirection: 'row' }}>
          <StageDisplay stage={recipe?.stages[recipe.activeStage]} />
          {/* <div style={{ flex: 0.5 }}>
            <h2>Time enlapsed</h2>
            <h2>{currTime} s</h2>
            <h3>Product temperature {currProdTemp} F</h3>
            <h3>Grill temperature {currGrillTemp} F</h3>
          </div>
          <div style={{ flex: 0.5 }}>

            <h2>Stage Parameters</h2>
            <h3>Target Product Temperature {recipe?.stages[recipe.activeStage].product_temperature_f} F</h3>
            <h3>Target Grill Temperature {recipe?.stages[recipe.activeStage].grill_temperature_f} F</h3>
            <h3>Stage duration {Math.fround(recipe?.stages[recipe.activeStage].time_s / 60).toFixed(1)} min</h3>
          </div> */}
        </div>
        <div className="right" style={{ display: 'flex', flexDirection: 'column' }}>
          <Stages recipe={recipe} activeStage={recipe?.activeStage} />
        </div>
      </article>
    </>
  )
}